import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../components/LeadDetails.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LeadDetails = () => {
  const { id } = useParams();
  const [lead, setLead] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [statusEditMode, setStatusEditMode] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [nextFollowup, setNextFollowup] = useState("");

  const [formData, setFormData] = useState({
    lead_name: "",
    lead_phone: "",
    lead_reason: "",
    lead_date: "",
    lead_status: 1,
    lead_source: "",
      lead_campaign: "",   // ✅ ADD
  lead_city: "",       // ✅ ADD
  });

  const [statusForm, setStatusForm] = useState({
    lead_status: 1,
  });

  // ✅ Fetch lead details
  const fetchLead = async () => {
    try {
      const token = (localStorage.getItem("session_token") || "").trim();
      const base = "https://newerp.awasthivitality.com/api";
      const viewUrl = new URL(`${base}/lead/view/${id}`);
      if (token) viewUrl.searchParams.set("token", token);
      viewUrl.searchParams.set("_ts", Date.now().toString());

      const res = await fetch(viewUrl, { headers: { Accept: "application/json" } });
      const result = await res.json();

    // Inside fetchLead, update the setFormData part:
if (res.ok && result.success && result.data) {
  const data = result.data;
  setLead(data);
  
  // Normalize source: if it's not manual/digital, default to manual
  const normalizedSource = ["manual", "digital"].includes(data.lead_source?.toLowerCase()) 
    ? data.lead_source.toLowerCase() 
    : "manual";

  setFormData({
    lead_name: data.lead_name || "",
    lead_phone: data.lead_phone || "",
    lead_reason: data.lead_reason || "",
lead_date: data.lead_date
  ? new Date(data.lead_date).toISOString().split("T")[0]
  : "",
      lead_status: data.lead_status || 1,
    lead_source: normalizedSource, // Cleaned source
      lead_campaign: data.lead_campaign || "",
  lead_city: data.lead_city || "",
  });
  setStatusForm({ lead_status: data.lead_status || 1 });
}else {
        toast.error("Failed to load lead details.");
      }
    } catch (error) {
      console.error("Fetch lead error:", error);
      toast.error("Error fetching lead details.");
    }
  };

  // ✅ Fetch status options
  const fetchStatusOptions = async () => {
    try {
      const res = await fetch(
        "https://newerp.awasthivitality.com/api/lead/status-options"
      );
      const result = await res.json();
      if (res.ok && result.success) {
        setStatusOptions(result.data);
      }
    } catch (error) {
      console.error("Fetch status options error:", error);
    }
  };

  // ✅ Fetch source options
  const fetchSourceOptions = async () => {
    try {
      const res = await fetch(
        "https://newerp.awasthivitality.com/api/lead/source-options"
      );
      const result = await res.json();
      if (res.ok && result.success) {
        setSourceOptions(result.data);
      }
    } catch (error) {
      console.error("Fetch source options error:", error);
    }
  };

  // ✅ Fixed Fetch Comments (Main Fix)
  const fetchComments = async () => {
    try {
      const token = (localStorage.getItem("session_token") || "").trim();
      const url = new URL(
        `https://newerp.awasthivitality.com/api/lead/comments/${id}`
      );
      if (token) url.searchParams.set("token", token);
      url.searchParams.set("_ts", Date.now().toString());

      const res = await fetch(url.toString(), {
        headers: { Accept: "application/json" },
      });
      const result = await res.json();

      if (res.ok && result.success && Array.isArray(result.data)) {
        const sorted = result.data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setComments(sorted);
      } else {
        console.warn("Unexpected comments structure:", result);
        setComments([]);
      }
    } catch (error) {
      console.error("Fetch comments error:", error);
      setComments([]);
    }
  };

  useEffect(() => {
    fetchLead();
    fetchStatusOptions();
    fetchSourceOptions();
    fetchComments();
  }, [id]);

  if (!lead) return <p style={{ padding: "20px" }}>Loading lead details...</p>;

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setStatusForm((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Update Lead
const handleUpdate = async (e) => {
  e.preventDefault();
  try {
    const token = (localStorage.getItem("session_token") || "").trim();

    // 1. Double-check source validity right before sending
    const validSources = ["manual", "digital"];
    const submittedSource = formData.lead_source?.toLowerCase().trim();
    
    const finalSource = validSources.includes(submittedSource) 
      ? submittedSource 
      : "manual";

    // 2. Build Clean Payload
    const payload = {
      lead_name: formData.lead_name,
      lead_phone: formData.lead_phone,
      lead_reason: formData.lead_reason,
      lead_date: formData.lead_date,
      lead_status: formData.lead_status,
      lead_source: finalSource, 
        // ✅ REQUIRED BY BACKEND
  lead_campaign: formData.lead_campaign || "",
  lead_city: formData.lead_city || "",
    };

    const res = await fetch(
      `https://newerp.awasthivitality.com/api/lead/update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await res.json();
    
    if (res.ok && result.success) {
      toast.success("Lead updated successfully!");
      setEditMode(false);
      await fetchLead(); // Refresh UI
    } else {
      // If backend still complains, show the specific error message
      const errorMsg = result.msg || result.message || "Validation Error";
      toast.error(`Update Failed: ${errorMsg}`);
      console.error("Backend Validation Errors:", result.errors); 
    }
  } catch (error) {
    console.error("Update error:", error);
    toast.error("Network error while updating lead.");
  }
};

  // ✅ Update Status
const handleStatusUpdate = async (e) => {
  e.preventDefault();
  try {
    const token = (localStorage.getItem("session_token") || "").trim();
    
    // Send as a JSON body instead of URL parameters
    const res = await fetch(
      `https://newerp.awasthivitality.com/api/lead/update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          ...formData, // Keep existing data
          lead_status: statusForm.lead_status, // Update with new status
        }),
      }
    );

    const result = await res.json();

    if (res.ok && result.success) {
      toast.success("Lead status updated successfully!");
      setStatusEditMode(false);
      // 🔥 CRITICAL: Refresh both the lead and comments
      await fetchLead(); 
      await fetchComments();
    } else {
      toast.error(result.msg || "Failed to update status.");
    }
  } catch (error) {
    console.error("Status update error:", error);
    toast.error("Error updating status.");
  }
};

  // ✅ Add Comment
  const handleAddComment = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) {
      toast.warning("Please enter a comment");
      return;
    }

    try {
      let formattedFollowup = "";
      if (nextFollowup) {
        const dt = new Date(nextFollowup);
        formattedFollowup = `${dt.getFullYear()}-${String(
          dt.getMonth() + 1
        ).padStart(2, "0")}-${String(dt.getDate()).padStart(
          2,
          "0"
        )} ${String(dt.getHours()).padStart(2, "0")}:${String(
          dt.getMinutes()
        ).padStart(2, "0")}:00`;
      }

      const token = (localStorage.getItem("session_token") || "").trim();
      const params = new URLSearchParams();
      params.set("lead_comments", newComment);
      if (formattedFollowup) params.set("lead_followup", formattedFollowup);
      if (token) params.set("token", token);

      const res = await fetch(
        `https://newerp.awasthivitality.com/api/lead/comment/add/${id}?${params}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      const result = await res.json();
      if (res.ok && result.success) {
        toast.success("Comment added!");
        setNewComment("");
        setNextFollowup("");
        fetchComments();
      } else {
        toast.error("Failed to add comment.");
      }
    } catch (error) {
      console.error("Add comment error:", error);
      toast.error("Error adding comment.");
    }
  };

  const statusLabel =
    statusOptions.find((opt) => opt.value === lead.lead_status)?.label ||
    lead.status_text ||
    "Open";

  return (
    <div className="lead-details-page">
      <div className="lead-left">
        <div className="card">
          <h4>Contact Name</h4>
          <div className="contact-info">
            <img
              src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
              alt="profile"
              className="avatar"
            />
            <div>
              <h5>{lead.lead_name}</h5>
              <p>@ Lead ID: {lead.lead_id}</p>
            </div>
          </div>
        </div>

        <div className="card">
          <h4>Lead Information</h4>
          <p>
            <strong>Phone No:</strong>{" "}
            <span className="highlight">{lead.lead_phone}</span>
          </p>
          <p>
            <strong>Disease:</strong> {lead.lead_reason}
          </p>
          <p>
            <strong>Lead Date:</strong>{" "}
            {new Date(lead.lead_date).toLocaleDateString()}
          </p>
         <p>
  <strong>Created At:</strong>{" "}
  {lead.created_at
    ? new Date(lead.created_at).toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true, // shows AM/PM
      })
    : "N/A"}
</p>
          <p>
            <strong>Lead Source:</strong>{" "}
            <span className="highlight">{lead.lead_source}</span>
          </p>
            <p>
            <strong>Lead City:</strong>{" "}
            <span className="highlight">{lead.lead_city}</span>
          </p>
          <p>
            <strong>Lead Status:</strong>{" "}
            <strong className="highlight">{statusLabel}</strong>
          </p>
      <div className="button-container">
  <button 
    className="btn-danger" 
    onClick={() => setEditMode(true)}
    disabled={lead.lead_status2 === 1} // Disable if transferred
  >
    {lead.lead_status2 === 1 ? "Locked (Transferred)" : "Lead Edit"}
  </button>
  
  <button
    className="btn-success"
    onClick={() => setStatusEditMode(true)}
    disabled={lead.lead_status2 === 1} // Disable if transferred
  >
    Update Lead Status
  </button>
</div>
        </div>
      </div>

      <div className="lead-right">
        <div className="card">
          <h4>Add Comment</h4>
          <form onSubmit={handleAddComment} className="comment-form">
            <div className="form-group">
              <textarea
                placeholder=" "
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                required
              ></textarea>
              <label>Enter Comments</label>
            </div>

            <div className="form-group">
              <input
                type="datetime-local"
                placeholder=" "
                value={nextFollowup}
                onChange={(e) => setNextFollowup(e.target.value)}
              />
              <label>Next Follow-up</label>
            </div>

            <button type="submit" className="btn-success">
              Add Comment
            </button>
          </form>
        </div>

        <div className="card">
          <h4>Comments</h4>
          {comments.length > 0 ? (
            comments.map((c) => (
              <div key={c.id} className="comment-card">
                <div className="comment-header">
                  <strong>
                    {c.created_by ||
                      (c.user && c.user.user_name) ||
                      (c.user_id === 0 ? "Admin" : `User #${c.user_id}`)}
                  </strong>
                  <span>
                    {new Date(c.created_at).toLocaleString("en-IN", {
                      dateStyle: "medium",
                      timeStyle: "short",
                    })}
                  </span>
                </div>
                <p>
                  <strong>Next Follow-up:</strong>{" "}
                  {c.lead_followup ? (
                    <span className="followup-tag">
                      {new Date(c.lead_followup).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  ) : (
                    "Not set"
                  )}
                </p>
                <p>
                  <strong>Comments:</strong> {c.lead_comments}
                </p>
              </div>
            ))
          ) : (
            <p>No comments yet.</p>
          )}
        </div>
      </div>

      {/* Edit Lead Modal */}
      {editMode && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h4>Edit Lead</h4>
        <form onSubmit={handleUpdate} className="lead-edit-grid">
  <div className="form-field">
    <label>Patient Name:</label>
    <input
      type="text"
      name="lead_name"
      value={formData.lead_name}
      onChange={handleChange}
    />
  </div>

  <div className="form-field">
    <label>Mobile No.:</label>
    <input
      type="text"
      name="lead_phone"
      value={formData.lead_phone}
      onChange={handleChange}
    />
  </div>

  <div className="form-field">
    <label>Disease:</label>
    <input
      type="text"
      name="lead_reason"
      value={formData.lead_reason}
      onChange={handleChange}
    />
  </div>

  <div className="form-field">
    <label>Date:</label>
    <input
      type="date"
      name="lead_date"
      value={formData.lead_date}
      onChange={handleChange}
    />
  </div>

  <div className="form-field">
    <label>Lead Source:</label>
    <select
      name="lead_source"
      value={formData.lead_source}
      onChange={handleChange}
    >
      {sourceOptions.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
<div className="form-field">
  <label>Campaign:</label>
  <input
    type="text"
    name="lead_campaign"
    value={formData.lead_campaign}
    onChange={handleChange}
  />
</div>

<div className="form-field">
  <label>City:</label>
  <input
    type="text"
    name="lead_city"
    value={formData.lead_city}
    onChange={handleChange}
  />
</div>
  {/* Buttons row */}
  <div className="form-actions full-width">
    <button type="submit" className="btn-success">Update Lead</button>
    <button
      type="button"
      className="btn-danger"
      onClick={() => setEditMode(false)}
    >
      Cancel
    </button>
  </div>
</form>

          </div>
        </div>
      )}

      {/* Status Edit Modal */}
      {statusEditMode && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h4>Update Lead Status</h4>
            <form onSubmit={handleStatusUpdate}>
              <label>Status:</label>
              <select
                name="lead_status"
                value={statusForm.lead_status}
                onChange={handleStatusChange}
              >
                {statusOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              <div className="modal-buttons">
                <button type="submit" className="btn-success">
                  Update Status
                </button>
                <button
                  type="button"
                  className="btn-danger"
                  onClick={() => setStatusEditMode(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default LeadDetails;